The primary email address of the candidate.
